<template>
    <div class="exportProjectData">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>一点彩票</el-breadcrumb-item>
            <el-breadcrumb-item>彩票交易数据</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form :inline="true" ref="exportProjectForm" class="exportProjectForm" :rules="validateRules" :model="exportProjectForm" align="left">
            <el-form-item label="日期" prop="dateTime">
                <el-date-picker v-model="exportProjectForm.dateTime" type="daterange" align="left" :editable="false" range-separator="/" placeholder="选择日期范围" :picker-options="pickerOptions"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="exportData('exportProjectForm')">立即导出</el-button>
                <el-button @click="cancal">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
export default {
    name: "exportProjectData",
    data() {
        return {
            exportProjectForm: {
                dateTime: null
            },
            validateRules: {
                dateTime: [
                    { required: true, type: 'array', message: '请选择日期', trigger: 'blur' }
                ]
            },
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }],
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            }
        };
    },
    mounted(){
        this._init();
    },
    methods: {
        _confirmMessage(message, success = ()=>{}, cancel = ()=>{}) {
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(success).catch(cancel);
        },
        exportData(formName){
            let flag = true,
                url;
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                return;
            }
            if (this.exportProjectForm.dateTime.length !== 2) {
                this.$notify.error({
                    message: "【营销平台】日期格式有误"
                });
                return;
            }
            let dateTime = {
                begin: new Date(this.exportProjectForm.dateTime[0]).format("yyyy-MM-dd 00:00:00"),
                end: new Date(this.exportProjectForm.dateTime[1]).format("yyyy-MM-dd 23:59:60")
            };
            url = CONFIG.HOST + "/lotteryTicketLog/getLotteryTicketLogs?startTime=" + dateTime.begin + "&endTime=" + dateTime.end;
            window.open(url);
        },
        _init() {
            Date.prototype.format = function(fmt) {
                var o = {
                    "M+" : this.getMonth()+1,                 //月份
                    "d+" : this.getDate(),                    //日
                    "h+" : this.getHours(),                   //小时
                    "m+" : this.getMinutes(),                 //分
                    "s+" : this.getSeconds(),                 //秒
                    "q+" : Math.floor((this.getMonth()+3)/3), //季度
                    "S"  : this.getMilliseconds()             //毫秒
                };
                if(/(y+)/.test(fmt)) {
                        fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
                }
                for(var k in o) {
                    if(new RegExp("("+ k +")").test(fmt)){
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
                    }
                }
                return fmt;
            }
        },
        cancal(){
          let self = this;
          self.exportProjectForm.dateTime = null;
        }
    }
};
</script>
<style lang="less">
    .exportProjectData{
        width: 98%;
        margin: 0 auto;
        .bread-nav{
            margin: 20px 0;
        }
        .exportProjectForm{
            text-align: left;
            .select-box{
                width: 220px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// DealData.vue?0423446a